import React from 'react';

type SpinnerSize = 'small' | 'medium' | 'large';

interface LoadingSpinnerProps {
  size?: SpinnerSize;
  className?: string;
  label?: string;
}

const sizeMap: Record<SpinnerSize, { width: string; border: string }> = {
  small: { width: '1rem', border: '2px' },
  medium: { width: '1.5rem', border: '2.5px' },
  large: { width: '2.5rem', border: '3px' },
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  className = '',
  label = 'Loading',
}) => {
  const { width, border } = sizeMap[size];

  return (
    <span
      role="status"
      aria-label={label}
      className={`inline-block animate-spin rounded-full ${className}`}
      style={{
        width,
        height: width,
        border: `${border} solid #E5E7EB`,
        borderTopColor: '#374151',
      }}
    >
      <span className="sr-only">{label}</span>
    </span>
  );
};

export default LoadingSpinner;
